import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagesComponent } from 'src/common/components';
import { Form, FormElement, FormElementValidators } from 'src/common/form';
import { Auth, AuthenticationResetModel } from 'src/common/security';
import { environment } from 'src/environments/environment';
import { TranslationManager } from 'src/common/translation';





@Component({
    selector: 'new-password',
    templateUrl: './new-password.component.html'
})
export class NewPasswordComponent implements OnInit {

    form: Form = new Form();
    passwordNotMatch: boolean = false;
    passwordToken: string;
    readonly environment = environment;
    translationManager = TranslationManager;

    constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {
        this.initForm();

         this.activatedRoute.paramMap.subscribe((value: any) => {
            this.passwordToken = value.params.id;
         });
    }

    resetPassword() {
        this.passwordNotMatch = false;

        if (this.form.isValid()) {
            var newPassword = this.form.elements['newpassword'].value;
            var confirmedPassword = this.form.elements['confirmpassword'].value;

            if(newPassword != confirmedPassword) {
                this.passwordNotMatch = true;
                return;
            }

            let resetModel: AuthenticationResetModel = new AuthenticationResetModel();
            resetModel.newPassword = newPassword;
            resetModel.resetPasswordToken = this.passwordToken;

            Auth.resetPassword(resetModel).then(() => {
                //MessagesComponent.instance.showSuccess(['Корисничка лозинка је успешно промењена']);
                MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Корисничка лозинка је успешно промењена')]);

                this.router.navigate(['/login']);
            });
        }
    }

    private initForm() {
        this.form.elements['newpassword'] = new FormElement();
        this.form.elements['newpassword'].state.mandatory = true;
        this.form.elements['newpassword'].onValidation = FormElementValidators.stringValidator;

        this.form.elements['confirmpassword'] = new FormElement();
        this.form.elements['confirmpassword'].state.mandatory = true;
        this.form.elements['confirmpassword'].onValidation = FormElementValidators.stringValidator;
    }

}
